module.exports = __webpack_public_path__ + "static/FirstPCBuild-5b851046d5bb223559f444272650be35.jpg";